import { render, staticRenderFns } from "./activate-device.vue?vue&type=template&id=fbb988e6"
import script from "./activate-device.vue?vue&type=script&lang=js"
export * from "./activate-device.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports